export const formatEuro = value => {
    let formatter = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR"
    })
    return formatter.format(value)
}